import { faVial } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';

export const TestIcon = (props: { color: string }) => {
  return (
    <FontAwesomeIcon icon={faVial} color={props.color} />
  )
}
